/**
 * Whether the pilot has asked the system for less motion.
 *
 * CSS handles everything the stylesheet animates (`globals.css`). This is for
 * motion made in script, which that rule cannot reach: a map easing to fit a
 * set of tracks, a tile fading in.
 */
export function prefersReducedMotion(): boolean {
  return (
    typeof globalThis.matchMedia === 'function' &&
    globalThis.matchMedia('(prefers-reduced-motion: reduce)').matches
  );
}

/** A duration in milliseconds, or none at all under reduced motion. */
export function motionDuration(ms: number): number {
  return prefersReducedMotion() ? 0 : ms;
}
